export const config = {
    "dev": {
        "login": "superadmin",
        "pass": "admin5",
    },
    "constsPropName": "$const",
    "autologin_delay": 120000, //2minuty? @miliseconds 30000
    "messages_check_interval": 30000, //2minuty? @miliseconds 30000
    "login_header_name": "x-fifth-cms-user",
    "login_local_storage_name": "login_token",
    "lang_id_local_storage_name": "lang_token",
    "lang_id_default_value": "cz",
    "filter_ident": "_filter_dev2",
    "path": {
        "login_form": "/",
        "dashboard": "/dashboard"
    },
    "flash_messages":{
        "root_local_storage_name": "flashes_v_dev",
    },
    "allowed_query_names": [
        "id",
        "page",
        "order",
        "filter",
        "date",
    ],
    "map": {
        "localStorageIdent": "gpsStorage_dev5",
        "mapBoxStyleUrl": "https://api.mapbox.com/styles/v1/jiri-vyhnal/cm7cgkywz007t01ry8nc5fnk2/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoiamlyaS12eWhuYWwiLCJhIjoiY203YzZsYTBsMDQ0bDJqcjFob3gxOXNiciJ9.f5rHI8mMEUGDTYzsgdseXA",
        "defaultPosition": {
            "lat": 50.0796983,
            "lng": 14.4403297,
        },
        geocodingSearchURL: `https://nominatim.openstreetmap.org/reverse?format=json&addressdetails=1`,
        geocodingReverseSearchURL: `https://nominatim.openstreetmap.org/reverse?format=json&addressdetails=1`,
        venue: {
            radius: 1500
        }
    },
    "venue": {
        "google_api_key": "AIzaSyDUo3liD5bxUo2NP33HR2bMkqxP7ihV_RA"
    },
    "modul": {
        "venue": {
            "filter_types": [
                "street_address",
                "point_of_interest",
                //"locality",
                "premise",
            ],
            "last_position_key": "venue_last_position_key_dev1",
            "default_position": {
                lat:49.19558079835405,
                lng: 16.605630092021983
            }
        },
    },
    "style": {
        "class_drag_n_drop": "ghost-drag-n-drop"
    },
    "is_flash_message": false,
    "wiki": {
        "image_id": 1,

    }
};
